<div>
    <h2>{{'etiquetado.titulo' | translate}}</h2>
    <div class="filters-info" *ngIf="filtersVisible">{{'global.infoRequired' | translate}}</div>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.pais' | translate}} *</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')"
                    [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'etiquetado.filters.denominacion' | translate}} *</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                    [disabled]="disabledDenominaciones" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'etiquetado.filters.campanya' | translate}} *</label>
                <app-filterable-list [itemsList]="campanyas" [selectedItem]="filtersForm.get('campanya')"
                    [disabled]="disabledCampanya" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'etiquetado.filters.etiquetador' | translate}}</label>
                <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')"
                    [disabled]="disabledEtiquetadores" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.almacen' | translate}}</label>
                <app-filterable-list [itemsList]="almacenes" [selectedItem]="filtersForm.get('almacen')"
                    [disabled]="disabledAlmacenes" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'etiquetado.filters.marca' | translate}}</label>
                <app-filterable-list [itemsList]="marcas" [selectedItem]="filtersForm.get('marca')"
                    [disabled]="disabledMarcas" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'etiquetado.filters.destino' | translate}}</label>
                <app-filterable-list [itemsList]="destinos" [selectedItem]="filtersForm.get('paisDestino')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
                    (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
                    (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <input type="checkbox" id="dsgConfeccionadas" formControlName="dsgConfeccionadas">
              <label for="dsgConfeccionadas">{{'etiquetado.filters.dsgConfeccionadas' | translate}}</label>
          </div>
            <div class="alignment-start-filters" [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
              <input type="checkbox" id="desgloseAlmacen" formControlName="desgloseAlmacen">
              <label [ngStyle]="filtersForm.get('desgloseAlmacen')?.disabled ? {'color': '#999'} : {}" for="desgloseAlmacen">{{'etiquetado.filters.desgloseAlmacen' | translate}}</label>
          </div>
          <div *ngIf="this.isSmallScreen" class="entry-3-small"></div>
          <div *ngIf="this.isSmallScreen" class="entry-3-small"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons">
        <i class="fas fa-file-pdf" [ngClass]="{'disabled': !etiquetado || etiquetado.length < 1}"
          (click)="exportModal = 1" title="{{'mantenimientoIncidencias.exportarA' | translate}} PDF"></i>
        <i class="fas fa-file-csv" [ngClass]="{'disabled': !etiquetado || (etiquetado && etiquetado.length < 1)}"
            (click)="exportModal = 3" title="{{'titles.exportarCSV' | translate}}"></i>
        <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <section class="no-data" *ngIf="!etiquetado || etiquetado.length === 0">
        {{'global.noContent' | translate}}
    </section>
    <section class="tabs" *ngFor="let informacion of etiquetado; let i = index">
        <content class="table-list" *ngIf="i < lastItemList && i >= firstItemList">
            <div class="title">
                <label>{{informacion.desEtiquetador}}</label>
                <div><label>{{'global.unidades' | translate}}: </label> {{informacion.sumaNumEtiquetasImpresasEfectivas | number : '' : defaultLanguage}}
                    ({{informacion.sumaKgImpresosEfectivos | number : '.2' : defaultLanguage}}Kg / {{informacion.sumaKgDesignados |
                        number : '.2' : defaultLanguage}}Kg)</div>
                </div>
                <ng-container *ngIf="breakdownPackhouse">
                    <div class="list" *ngFor="let almacen of informacion.lsEtiquetadoAlmacenDto; let j = index;">
                        <div class="list-title">
                            <div>
                                <label>{{'global.almacen' | translate}}: </label>
                                {{almacen.desAlmacen}}
                            </div>
                            <div>
                                <label>{{'global.unidades' | translate}}: </label>
                                {{almacen.sumaNumEtiquetasImpresasEfectivas | number : '' : defaultLanguage}}
                                ({{almacen.sumaKgImpresosEfectivos | number : '.2' : defaultLanguage}}Kg /
                                {{almacen.sumaKgDesignados | number : '.2' : defaultLanguage}}Kg)
                            </div>
                        </div>
                        <div class="table-wrapper-smaller">
                            <div class="table-container">
                                <table>
                                    <thead>
                                        <tr>
                                            <th class="icon"></th>
                                            <th class="icon"></th>
                                            <th class="string sortable" (click)="toOrderBy('2'+i+j, 2, 'desFinca', 'x=> x.desFinca')">
                                            {{'global.finca' | translate}}
                                            <div class="sortable-icons">
                                                <i [ngClass]="getIcon(2)"></i>
                                            </div>
                                            </th>
                                            <th class="string sortable" (click)="toOrderBy('3'+i+j, 3,  'desMarca', 'x=> x.desMarca')">
                                                {{'etiquetado.table.marca' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon(3)"></i>
                                                </div>
                                            </th>
                                            <th class="string sortable" (click)="toOrderBy('4'+i+j, 4,  'productores', 'x=> x.productores')">
                                                {{'etiquetado.table.productor' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon(4)"></i>
                                                </div>
                                            </th>
                                            <!-- <th class="string sortable" (click)="toOrderBy('5'+i+j)" [appSort]="almacen.lsEtiquetadoCultivoDto" data-order="desc" data-name="nLicencia">
                                                {{'etiquetado.table.licencia' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon('5'+i+j)"></i>
                                                </div>
                                            </th> -->
                                            <!-- <th class="string sortable" (click)="toOrderBy('6'+i+j)" [appSort]="almacen.lsEtiquetadoCultivoDto" data-order="desc" data-name="desProvincia">
                                                {{'global.provincia' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon('6'+i+j)"></i>
                                                </div>
                                            </th> -->
                                            <th class="string sortable" (click)="toOrderBy('7'+i+j, 7, 'desMunicipio', 'x=> x.desMunicipio')">
                                                {{'global.municipio' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon(7)"></i>
                                                </div>
                                            </th>
                                            <!-- <th class="string sortable" (click)="toOrderBy('8'+i+j)" [appSort]="almacen.lsEtiquetadoCultivoDto" data-order="desc" data-name="poligonoCatastral">
                                                {{'etiquetado.table.poligono' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon('8'+i+j)"></i>
                                                </div>
                                            </th>
                                            <th class="string sortable" (click)="toOrderBy('9'+i+j)" [appSort]="almacen.lsEtiquetadoCultivoDto" data-order="desc" data-name="parcelaCatastral">
                                                {{'etiquetado.table.parcela' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon('9'+i+j)"></i>
                                                </div>
                                            </th> -->
                                            <th class="number sortable" (click)="toOrderBy('10'+i+j, 10, 'sumaNumEtiquetasImpresasEfectivas', 'x=> x.sumaNumEtiquetasImpresasEfectivas')">
                                                {{'global.unidades' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon(10)"></i>
                                                </div>
                                            </th>
                                            <th class="number sortable" (click)="toOrderBy('11'+i+j, 11, 'sumaKgImpresosEfectivos', 'x=> x.sumaKgImpresosEfectivos')">
                                                {{'global.confeccionadoKg' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon(11)"></i>
                                                </div>
                                            </th>
                                            <th class="number sortable" (click)="toOrderBy('12'+i+j, 12, 'sumaKgDesignados', 'x=> x.sumaKgDesignados')">
                                                {{'etiquetado.table.designado' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon(12)"></i>
                                                </div>
                                            </th>
                                            <th id="12" class="progress">
                                                {{'global.porcentajeConfeccionado' | translate}}
                                            </th>
                                            <th class="action-short"></th>
                                        </tr>
                                    </thead>
                                    <tbody *ngFor="let cultivo of almacen.lsEtiquetadoCultivoDto; let k = index;">
                                        <tr (click)="showDetails('index'+i+j+k);" [ngClass]="{'dropdownInfo': dropdownInfo === 'index'+i+j+k}" style="cursor: pointer;">
                                            <td class="icon"><i [ngClass]="dropdownInfo === 'index'+i+j+k ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                                            title="{{dropdownInfo === 'index'+i+j+k ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                                            </td>
                                            <td class="icon">
                                                <a *ngIf="cultivo.consumoVechain?.existeRegBlockchain && (claims.includes('D_EC_InfoBlockchainVisible') || this.role === 'Administrador')" href={{cultivo.consumoVechain.txIdExplore}} target="_blank">
                                                    <i class="fas fa-circle-nodes" style="cursor: pointer;" title="{{'global.blockchain.verBlockchain' | translate}}" app-click-stop-propagation ></i>
                                                </a>
                                            </td>
                                            <td class="string">{{cultivo.desFinca}}</td>
                                            <td class="string">{{cultivo.desMarca}}</td>
                                            <td class="string">{{cultivo.productores}}</td>
                                            <!-- <td class="string">{{cultivo.nLicencia}}</td> -->
                                            <!-- <td class="string">{{cultivo.desProvincia}}</td> -->
                                            <td class="string" title="{{cultivo.desMunicipio}} ({{cultivo.desProvincia}})">{{cultivo.desMunicipio}}</td>
                                            <!-- <td class="string">{{cultivo.poligonoCatastral}}</td>
                                            <td class="string">{{cultivo.parcelaCatastral}}</td> -->
                                            <td class="number">{{cultivo.sumaNumEtiquetasImpresasEfectivas | number : '1.0-0': defaultLanguage}}</td>
                                            <td class="number">{{cultivo.sumaKgImpresosEfectivos | number : '1.2-2': defaultLanguage}}</td>
                                            <td class="number">{{cultivo.sumaKgDesignados | number : '1.2-2': defaultLanguage}}</td>
                                            <td class="progress"><progress
                                                    [ngClass]="{'exceeded': (+getPercent(cultivo.sumaKgImpresosEfectivos, cultivo.sumaKgDesignados)>100)}"
                                                    value="{{getPercent(cultivo.sumaKgImpresosEfectivos, cultivo.sumaKgDesignados)}}"
                                                    max="100"></progress><span>{{getPercent(cultivo.sumaKgImpresosEfectivos,
                                                    cultivo.sumaKgDesignados)}}%</span>
                                            </td>
                                            <td class="action-short">
                                                <i class="fas fa-stream" (click)="showSection('index'+i+j+k)" app-click-stop-propagation
                                                title="{{(dropdownSection === 'index'+i+j+k )? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                                            </td>
                                        </tr>
                                        <tr *ngIf="dropdownInfo === 'index'+i+j+k">
                                        <td colspan="11">
                                            <div class="detail">
                                            <div class="title" style="justify-content: center;">{{'global.masInformacion' | translate}}</div>
                                            <div class="block-inline">
                                                <label>{{'etiquetado.table.denominacion' | translate}}</label>
                                                <p>{{cultivo.desDenominacion}}</p>
                                            </div>
                                            <div class="block-inline">
                                                <label>{{'global.provincia' | translate}}</label>
                                                <p>{{cultivo.desProvincia}}</p>
                                            </div>
                                            </div>
                                        </td>
                                        </tr>
                                        <!-- Campos blockchain -->
                                        <tr *ngIf="dropdownInfo === 'index'+i+j+k && cultivo.consumoVechain?.existeRegBlockchain && (claims.includes('D_EC_InfoBlockchainVisible') || this.role === 'Administrador')">
                                        <td colspan="11">
                                            <div class="detail">
                                            <div class="title" style="justify-content: center;">{{'global.blockchain.informacion.titulo' | translate}}</div>
                                            <div class="block-inline">
                                                <label>{{'global.blockchain.informacion.blockchain' | translate}}</label>
                                                <p>{{cultivo.consumoVechain.blockchain}}</p>
                                            </div>
                                            <div class="block-inline gap">
                                                <label>{{'global.blockchain.informacion.fechaRegistro' | translate}}</label>
                                                <p>{{cultivo.consumoVechain.fechaRegistro | date: 'dd/MM/yyyy HH:mm:ss'}}</p>
                                            </div>
                                            <div class="block-inline gap nowrap">
                                                <label>{{'global.blockchain.informacion.input' | translate}}</label>
                                                <p>{{cultivo.consumoVechain.textoHash}}</p>
                                            </div>
                                            <div class="block-inline">
                                                <label></label>
                                                <p></p>
                                            </div>
                                            <div class="block-inline gap nowrap">
                                                <label>{{'global.blockchain.informacion.idCripto' | translate}}</label>
                                                <p>{{cultivo.consumoVechain.txId}}</p>
                                            </div>
                                            <div class="block-inline">
                                                <label></label>
                                                <p></p>
                                            </div>
                                            <div class="block-inline">
                                                <label></label>
                                                <p></p>
                                            </div>
                                            <div class="block-inline">
                                                <label></label>
                                                <p></p>
                                            </div>
                                            <div class="block-inline gap nowrap">
                                                <label>{{'global.blockchain.informacion.hash' | translate}}</label>
                                                <p>{{cultivo.consumoVechain.hash}}</p>
                                            </div>
                                            <div class="block-inline">
                                                <label></label>
                                                <p></p>
                                            </div>
                                            <div class="block-inline">
                                                <label></label>
                                                <p></p>
                                            </div>
                                            <div class="block-inline">
                                                <label></label>
                                                <p></p>
                                            </div>
                                            </div>
                                        </td>
                                        </tr>
                                        <tr *ngIf="dropdownSection === 'index'+i+j+k">
                                            <td colspan="6">
                                            <section class="tabs">
                                                <ul>
                                                <li [ngClass]="{'active': pestanaActiva[i] === 1}">{{'etiquetado.table.tabs.confeccion.titulo' | translate}}</li>
                                                </ul>
                                                <content>
                                                <app-desglose-confeccion-etiquetado [confecciones]="cultivo.lsEtiquetadoConfeccionDto"></app-desglose-confeccion-etiquetado>
                                                </content>
                                            </section>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot *ngIf="!etiquetado || (etiquetado && etiquetado.length < 1)">
                                        <tr>
                                            <td colspan="9">
                                                {{'global.noContent' | translate}}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!breakdownPackhouse">
                    <div class="list">
                        <div class="table-wrapper-smaller">
                            <div class="table-container">
                                <table>
                                    <thead>
                                        <tr>
                                            <th class="icon"></th>
                                            <th class="icon"></th>
                                            <th class="string sortable" (click)="toOrderBy('2'+i, 2, 'desFinca', 'x=> x.desFinca')">
                                            {{'global.finca' | translate}}
                                            <div class="sortable-icons">
                                                <i [ngClass]="getIcon(2)"></i>
                                            </div>
                                            </th>
                                            <th class="string sortable" (click)="toOrderBy('3'+i, 3,  'desMarca', 'x=> x.desMarca')">
                                                {{'etiquetado.table.marca' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon(3)"></i>
                                                </div>
                                            </th>
                                            <th class="string sortable" (click)="toOrderBy('4'+i, 4,  'productores', 'x=> x.productores')">
                                                {{'etiquetado.table.productor' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon(4)"></i>
                                                </div>
                                            </th>
                                            <!-- <th class="string sortable" (click)="toOrderBy('5'+i)" [appSort]="almacen.lsEtiquetadoCultivoDto" data-order="desc" data-name="nLicencia">
                                                {{'etiquetado.table.licencia' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon('5'+i)"></i>
                                                </div>
                                            </th> -->
                                            <!-- <th class="string sortable" (click)="toOrderBy('6'+i)" [appSort]="almacen.lsEtiquetadoCultivoDto" data-order="desc" data-name="desProvincia">
                                                {{'global.provincia' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon('6'+i)"></i>
                                                </div>
                                            </th> -->
                                            <th class="string sortable" (click)="toOrderBy('7'+i, 7, 'desMunicipio', 'x=> x.desMunicipio')">
                                                {{'global.municipio' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon(7)"></i>
                                                </div>
                                            </th>
                                            <!-- <th class="string sortable" (click)="toOrderBy('8'+i)" [appSort]="almacen.lsEtiquetadoCultivoDto" data-order="desc" data-name="poligonoCatastral">
                                                {{'etiquetado.table.poligono' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon('8'+i)"></i>
                                                </div>
                                            </th>
                                            <th class="string sortable" (click)="toOrderBy('9'+i)" [appSort]="almacen.lsEtiquetadoCultivoDto" data-order="desc" data-name="parcelaCatastral">
                                                {{'etiquetado.table.parcela' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon('9'+i)"></i>
                                                </div>
                                            </th> -->
                                            <th class="number sortable" (click)="toOrderBy('10'+i, 10, 'sumaNumEtiquetasImpresasEfectivas', 'x=> x.sumaNumEtiquetasImpresasEfectivas')">
                                                {{'global.unidades' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon(10)"></i>
                                                </div>
                                            </th>
                                            <th class="number sortable" (click)="toOrderBy('11'+i, 11, 'sumaKgImpresosEfectivos', 'x=> x.sumaKgImpresosEfectivos')">
                                                {{'global.confeccionadoKg' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon(11)"></i>
                                                </div>
                                            </th>
                                            <th class="number sortable" (click)="toOrderBy('12'+i, 12, 'sumaKgDesignados', 'x=> x.sumaKgDesignados')">
                                                {{'etiquetado.table.designado' | translate}}
                                                <div class="sortable-icons">
                                                    <i [ngClass]="getIcon(12)"></i>
                                                </div>
                                            </th>
                                            <th id="12" class="progress">
                                                {{'global.porcentajeConfeccionado' | translate}}
                                            </th>
                                            <th class="action-short"></th>
                                        </tr>
                                    </thead>
                                    <tbody *ngFor="let cultivo of informacion.etiquetadoTotalDto.lsEtiquetadoCultivoDto; let k = index;">
                                        <tr (click)="showDetails('index'+i+k);" [ngClass]="{'dropdownInfo': dropdownInfo === 'index'+i+k}" style="cursor: pointer;">
                                            <td class="icon"><i [ngClass]="dropdownInfo === 'index'+i+k ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                                                title="{{dropdownInfo === 'index'+i+k ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                                            </td>
                                            <td class="icon">
                                                <a *ngIf="cultivo.consumoVechain?.existeRegBlockchain && (claims.includes('D_EC_InfoBlockchainVisible') || this.role === 'Administrador')" href={{cultivo.consumoVechain.txIdExplore}} target="_blank">
                                                    <i class="fas fa-circle-nodes" style="cursor: pointer;" title="{{'global.blockchain.verBlockchain' | translate}}" app-click-stop-propagation ></i>
                                                </a>
                                            </td>
                                            <td class="string">{{cultivo.desFinca}}</td>
                                            <td class="string">{{cultivo.desMarca}}</td>
                                            <td class="string">{{cultivo.productores}}</td>
                                            <!-- <td class="string">{{cultivo.nLicencia}}</td> -->
                                            <!-- <td class="string">{{cultivo.desProvincia}}</td> -->
                                            <td class="string" title="{{cultivo.desMunicipio}} ({{cultivo.desProvincia}})">{{cultivo.desMunicipio}}</td>
                                            <!-- <td class="string">{{cultivo.poligonoCatastral}}</td>
                                            <td class="string">{{cultivo.parcelaCatastral}}</td> -->
                                            <td class="number">{{cultivo.sumaNumEtiquetasImpresasEfectivas | number : '1.0-0': defaultLanguage}}</td>
                                            <td class="number">{{cultivo.sumaKgImpresosEfectivos | number : '1.2-2': defaultLanguage}}</td>
                                            <td class="number">{{cultivo.sumaKgDesignados | number : '1.2-2': defaultLanguage}}</td>
                                            <td class="progress"><progress
                                                [ngClass]="{'exceeded': (+getPercent(cultivo.sumaKgImpresosEfectivos, cultivo.sumaKgDesignados)>100)}"
                                                value="{{getPercent(cultivo.sumaKgImpresosEfectivos, cultivo.sumaKgDesignados)}}"
                                                max="100"></progress><span>{{getPercent(cultivo.sumaKgImpresosEfectivos,
                                                    cultivo.sumaKgDesignados)}}%</span>
                                            </td>
                                            <td class="action-short">
                                                <i class="fas fa-stream" (click)="showSection('index'+i+k)" app-click-stop-propagation
                                                title="{{(dropdownSection === 'index'+i+k )? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                                            </td>
                                        </tr>
                                        <tr *ngIf="dropdownInfo === 'index'+i+k">
                                            <td colspan="11">
                                                <div class="detail">
                                                    <div class="title" style="justify-content: center;">{{'global.masInformacion' | translate}}</div>
                                                    <div class="block-inline">
                                                        <label>{{'etiquetado.table.denominacion' | translate}}</label>
                                                        <p>{{cultivo.desDenominacion}}</p>
                                                </div>
                                                    <div class="block-inline">
                                                        <label>{{'global.provincia' | translate}}</label>
                                                        <p>{{cultivo.desProvincia}}</p>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <!-- Campos blockchain -->
                                        <tr *ngIf="dropdownInfo === 'index'+i+k && cultivo.consumoVechain?.existeRegBlockchain && (claims.includes('D_EC_InfoBlockchainVisible') || this.role === 'Administrador')">
                                            <td colspan="11">
                                                <div class="detail">
                                                    <div class="title" style="justify-content: center;">{{'global.blockchain.informacion.titulo' | translate}}</div>
                                                    <div class="block-inline">
                                                        <label>{{'global.blockchain.informacion.blockchain' | translate}}</label>
                                                        <p>{{cultivo.consumoVechain.blockchain}}</p>
                                                    </div>
                                                    <div class="block-inline gap">
                                                        <label>{{'global.blockchain.informacion.fechaRegistro' | translate}}</label>
                                                        <p>{{cultivo.consumoVechain.fechaRegistro | date: 'dd/MM/yyyy HH:mm:ss'}}</p>
                                                    </div>
                                                    <div class="block-inline gap nowrap">
                                                        <label>{{'global.blockchain.informacion.input' | translate}}</label>
                                                        <p>{{cultivo.consumoVechain.textoHash}}</p>
                                                    </div>
                                                    <div class="block-inline">
                                                        <label></label>
                                                        <p></p>
                                                    </div>
                                                    <div class="block-inline gap nowrap">
                                                        <label>{{'global.blockchain.informacion.idCripto' | translate}}</label>
                                                        <p>{{cultivo.consumoVechain.txId}}</p>
                                                    </div>
                                                    <div class="block-inline">
                                                        <label></label>
                                                        <p></p>
                                                    </div>
                                                    <div class="block-inline">
                                                        <label></label>
                                                        <p></p>
                                                    </div>
                                                    <div class="block-inline">
                                                        <label></label>
                                                        <p></p>
                                                    </div>
                                                    <div class="block-inline gap nowrap">
                                                        <label>{{'global.blockchain.informacion.hash' | translate}}</label>
                                                        <p>{{cultivo.consumoVechain.hash}}</p>
                                                    </div>
                                                    <div class="block-inline">
                                                        <label></label>
                                                        <p></p>
                                                    </div>
                                                    <div class="block-inline">
                                                        <label></label>
                                                        <p></p>
                                                    </div>
                                                    <div class="block-inline">
                                                        <label></label>
                                                        <p></p>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr *ngIf="dropdownSection === 'index'+i+k">
                                            <td colspan="6">
                                                <section class="tabs">
                                                    <ul>
                                                        <li [ngClass]="{'active': pestanaActiva[i] === 1}">{{'etiquetado.table.tabs.confeccion.titulo' | translate}}</li>
                                                    </ul>
                                                    <content>
                                                        <app-desglose-confeccion-etiquetado [confecciones]="cultivo.lsEtiquetadoConfeccionDto"></app-desglose-confeccion-etiquetado>
                                                    </content>
                                                </section>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot *ngIf="!etiquetado || (etiquetado && etiquetado.length < 1)">
                                        <tr>
                                            <td colspan="9">
                                                {{'global.noContent' | translate}}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </ng-container>
        </content>
    </section>
    <app-paginator
    *ngIf="(etiquetado && etiquetado.length > 0)"
    [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" [totalItems]="totalItems"
    [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
    (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event;showWarning=$event">
    </app-toast>
</div>
<div class="modal" *ngIf="exportModal > 0">
    <div class="modal-content">
      <header>
        <h4>{{'global.modalInformes.titulo' | translate}} {{exportModal === 1 ? 'PDF' : 'CSV'}}</h4>
        <i class="fas fa-times" (click)="exportModal = 0"></i>
      </header>
      <content>
        <button (click)="exportPdfOrCsv(1)">{{'global.modalInformes.general' | translate}}</button>
        <button (click)="exportPdfOrCsv(2)">{{'global.modalInformes.detallado' | translate}}</button>
      </content>
    </div>
</div>
